/* tslint:disable */
/* eslint-disable */
/**
 * notifications
 * notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationChannelUpdateListEntry
 */
export interface NotificationChannelUpdateListEntry {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    preference_type_id?: string;
    /**
     * 
     */
    type?: NotificationChannelUpdateListEntryTypeEnum;
    /**
     * 
     */
    value: boolean;
}


/**
 * @export
 */
export const NotificationChannelUpdateListEntryTypeEnum = {
    Email: 'email',
    Sms: 'sms',
    App: 'app',
} as const;
export type NotificationChannelUpdateListEntryTypeEnum = typeof NotificationChannelUpdateListEntryTypeEnum[keyof typeof NotificationChannelUpdateListEntryTypeEnum];


/**
 * Check if a given object implements the NotificationChannelUpdateListEntry interface.
 */
export function instanceOfNotificationChannelUpdateListEntry(value: object): value is NotificationChannelUpdateListEntry {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function NotificationChannelUpdateListEntryFromJSON(json: any): NotificationChannelUpdateListEntry {
    return NotificationChannelUpdateListEntryFromJSONTyped(json, false);
}

export function NotificationChannelUpdateListEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationChannelUpdateListEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'preference_type_id': json['preference_type_id'] == null ? undefined : json['preference_type_id'],
        'type': json['type'] == null ? undefined : json['type'],
        'value': json['value'],
    };
}

export function NotificationChannelUpdateListEntryToJSON(json: any): NotificationChannelUpdateListEntry {
    return NotificationChannelUpdateListEntryToJSONTyped(json, false);
}

export function NotificationChannelUpdateListEntryToJSONTyped(value?: NotificationChannelUpdateListEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'preference_type_id': value['preference_type_id'],
        'type': value['type'],
        'value': value['value'],
    };
}

